function TourPageListItem(props) {
    return (
        <li>
            <h2>
                <a href={props.tour.Url}>
                    {props.tour.Name}
                </a>
            </h2>
            <div className="tour">
                <img className="tourImage" src={props.tour.MainImage.Url + "?width=300&height=200"} alt={props.tour.Name} />
                <div className="tourInfo">
                    <p dangerouslySetInnerHTML={{ __html: props.tour.Description.substring(0,200) }} ></p>
                    <p>You save <span className="yousave">{props.tour.YouSave}%</span></p>
                    <a href={props.tour.Url}>Book now</a>
                </div>
            </div>
        </li>
    )
};
export default TourPageListItem;